import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Heart } from 'lucide-react';
export function Transformation() {
  const handleCTAClick = () => {
    // Fire Meta Pixel AddToCart event
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    // Redirect to Hotmart checkout
    window.open('https://pay.hotmart.com/S103405068E?bid=1770499895743', '_blank');
  };
  return <section className="py-5 bg-[#9d4b6b] text-white relative overflow-hidden" data-id="element-539">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-540">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-541">
          <defs data-id="element-542">
            <pattern id="flower" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-543">
              <circle cx="20" cy="20" r="1" fill="currentColor" data-id="element-544" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#flower)" data-id="element-545" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-546">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-6" data-id="element-547">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif mb-6 tracking-wide" data-id="element-548">
            IMAGINA ALGO DISTINTO
          </h2>
          <div className="w-24 h-1 bg-white/30 mx-auto rounded-full" data-id="element-549"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 items-center mb-5" data-id="element-550">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="space-y-6 text-lg md:text-xl font-light leading-relaxed" data-id="element-551">
            <p data-id="element-552">
              Despiertas una mañana y notas algo diferente. Él te mira con una
              chispa familiar, como cuando se enamoró de ti. Te sonríe. Te
              abraza por la cintura en la cocina. Se interesa de nuevo en ti.
            </p>
            <p data-id="element-553">
              Las conversaciones vuelven a fluir. Las risas regresan. La
              complicidad revive.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20 shadow-xl" data-id="element-554">
            <p className="text-lg md:text-xl mb-6" data-id="element-555">
              Sientes que vuelves a ser mujer, no solo mamá. Sientes que vuelves
              a ser su compañera, no solo su responsabilidad. Sientes que el
              amor renace.
            </p>
            <p className="font-serif text-2xl italic" data-id="element-556">
              Y tú sabes que ese renacer sucedió porque tomaste una decisión.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="text-center" data-id="element-557">
          <motion.button whileHover={{
          scale: 1.03,
          boxShadow: '0 15px 35px -8px rgba(255, 193, 7, 0.6)'
        }} whileTap={{
          scale: 0.98
        }} onClick={handleCTAClick} className="
              relative overflow-hidden group
              bg-gradient-to-r from-[#ffc107] via-[#ffb300] to-[#ffc107]
              bg-[length:200%_100%]
              text-[#2d2d2d] font-bold text-base md:text-lg
              py-3.5 px-8 rounded-full 
              shadow-[0_8px_25px_-5px_rgba(255,193,7,0.5)]
              hover:shadow-[0_15px_40px_-8px_rgba(255,193,7,0.7)]
              transition-all duration-300
              flex items-center justify-center gap-2.5
              border-2 border-[#ffc107]/30
              w-auto mx-auto
            " style={{
          animation: 'shimmer 3s ease-in-out infinite'
        }} data-id="element-558">
            <Heart className="w-5 h-5 relative z-10 fill-[#2d2d2d] text-[#2d2d2d]" style={{
            animation: 'heartbeat 1.4s ease-in-out infinite'
          }} data-id="element-559" />
            <span className="relative z-10 tracking-wide" data-id="element-560">
              Ver Cómo Lograrlo
            </span>
            <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1.5 transition-transform duration-300" data-id="element-561" />

            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-out" data-id="element-562" />
          </motion.button>
        </motion.div>
      </div>
    </section>;
}